import { action } from "mobx";
import { mybagGuest, mybagApiData } from "./services";

import { Utils } from "arv-reactcomponents";

class CommonActions {
  @action
  setBrandPageState(bool) {
    this.isBrandPage = bool;
  }
  @action
  setBrandDetails(details) {
    this.brandDetails = details;
  }
  @action
  changeBrandName(brandName) {
    this.brandName = brandName;
  }

  getProductDetailsForSkus() {
    mybagGuest(
      JSON.stringify({
        skus: this.guestCartSkuIdsList,
      }),
    ).then(
      action(res => {
        this.cartItems = res.data || [];
      }),
      action(err => {
        console.log(err);
      }),
    );
  }

  getCartIfLoggedIn() {
    mybagApiData().then(
      action(res => {
        Utils.localStorage.setItem("cart-guest", null);
        this.cartItems = res.data.products || [];
      }),
      action(err => {
        console.log(err);
      }),
    );
  }
}

export default CommonActions;



// WEBPACK FOOTER //
// ./src/stores/CommonStore/actions.js